import { notesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(notesStyles, {
    titleText: {
        variant: "h3",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    notesText: {
        size: 14,
    },
});
